export let doing = [
    {
        msg: [ 'Estaba jugando !!!, ya me dio hambre' ]
    },
    {
        msg: [ 'Fui a comprar media lunas' ]
    },
    {
        msg: [ '😷 Aburrido de esta cuarentena' ]
    },
    {
        msg: [ 'Estaba Durmiendo zzzZZ' ]
    },
    {
        msg: [ 'Quiero jugar 😾' ]
    }
]

export let aboutMe = [
    {
        msg: [ 'Soy de Argentina ' ]
    },
    {
        msg: [ 'Tengo 2 Años' ]
    },
    {
        msg: [ 'Me gusta escuchar musica y programar' ]
    },
    {
        msg: [ 'No me gusta mucho tanto frio 🥶' ]
    },
    {
        msg: [ 'Me gustan las media lunas y cafe' ]
    },
    {
        msg: [ 'Soy un CatBOT con react' ]
    }
]